export default "__VITE_ASSET___34qhdQK__"